import { render } from "./FirstComponent.vue?vue&type=template&id=52f6afb7&scoped=true&ts=true"
import script from "./FirstComponent.vue?vue&type=script&lang=ts"
export * from "./FirstComponent.vue?vue&type=script&lang=ts"

import "./FirstComponent.vue?vue&type=style&index=0&id=52f6afb7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f6afb7"]])

export default __exports__